<template>
  <div
    class="mdl-card mdl-shadow--2dp"
    style="margin-top: 1em;">
    <div class="mdl-card__title locked">
      {{ qnResponseSingle.card_title }}
    </div>
    <div class="mdl-card__actions mdl-card--border">

      <div
        v-if="showResults===false"
        class="ui inverted left labeled icon label"
        style="background-color:#263d4b;">
        <i class="hourglass start icon"/>
        {{ localization.surveyCardComponent.answerUnavailableText }} {{ resultsDateText }}
      </div>

      <div v-else>

        <router-link
          :to="{ name: 'Results', params: { formId: formId }, query: { uid: userId, lang: userLang, country: userCountry }}">
          <div
            class="ui left labeled button mdl-button mdl-js-button mdl-button-raised mdl-js-ripple-effect"
            style="position: absolute; right:0.5em; color: white;"
            tabindex="0">
            <a
              class="ui basic right pointing label"
              style="background-color: #3e5c73;color:white;">
              {{ resultsTextCount }}
            </a>
            <div class="ui tertiary circular button">
              {{ localization.actionButtonText.seeAnswersButton }} <i class="right chevron icon icon"/>
            </div>
          </div>
        </router-link>
        <br>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnsweredSurvey',
  props: {
    qnResponseSingle: {
      type: Object,
      required: true
    },
    formId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      startSurveyButtonId: 'startSurveyButtonId' + this._uid,
      linkLoadingButtonId: 'linkLoadingButton' + this._uid
    };
  },
  computed: {
    resultsTextCount: function () {
      let num = parseInt(this.qnResponseSingle.answers);
      let locale = this.userLang + '-' + this.userCountry;
      num = num.toLocaleString(locale);

      return '~' + num;
    },
    resultsDate () {
      return this.qnResponseSingle.unlock_date;
    },
    resultsDateText () {
      let date = new Date(this.resultsDate);
      let locale = this.userLang + '-' + this.userCountry;

      return date.toLocaleString(locale, {timeZone: 'UTC', month: 'short', day: 'numeric'});
    },
    showResults () {
      if (this.qnResponseSingle.unlock_date === null || new Date() > new Date(this.qnResponseSingle.unlock_date)) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/survey/onetime/AnsweredSurvey.vue